import { HttpClient } from '@angular/common/http';
import { Component, Input, ChangeDetectionStrategy, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IEnvironmentService } from '../../../../services/environment/environment.interface';
import { AuthAsResponse } from './auth-as.response';
import { CRMType, IDataService, IParsedDataResponse } from '../../../../services/data/data-service.interface';

@Component({
  selector: 'gtd-ui-auth-as',
  templateUrl: './auth-as.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthAsComponent {
  @Input() id: number;
  @Input() customClass = '';
  @Input() crmType: CRMType;
  @Input() buttonMode = false;
  @Input() disabled = false;
  private endpointApi: string;
  private globalData: IParsedDataResponse;

  constructor(
    private http: HttpClient,
    @Inject('IEnvironmentService') private envService: IEnvironmentService,
    @Inject('IDataService') private dataService: IDataService
  ) {
    this.endpointApi = this.envService.getVar('services.api') as string;
    this.globalData = this.dataService.getData();
  }

  authAs() {
    if (this.disabled) return;
    this.getUserData().subscribe((r: AuthAsResponse) => {
      localStorage.setItem('affiliate-token', r.data.user_data.token);
      localStorage.setItem('affiliate-active-user', '1');
      localStorage.removeItem('master-affiliate-token');
      window.open(`/${this.crmData.path}/app/dashboard`, '_blank');
    });
  }

  get crmData() {
    const crmTypeData: { [key in CRMType]: { path: string; tooltip: string } } = {
      affiliate: {
        path: `affiliates/${this.globalData.current_language}`,
        tooltip: $localize`:@@affiliate.sign_in:Sign In As Affiliate`,
      },
      advertiser: {
        path: 'advertisers',
        tooltip: $localize`:@@advertiser:Sign In As Advertiser`,
      },
    };
    return crmTypeData[this.crmType];
  }

  getUserData(): Observable<AuthAsResponse> {
    if (!this.crmType) {
      throw new Error('CRM type is required');
    }
    return this.http.post<any>(`${this.endpointApi}/widget/data`, {
      widget: 'Rbac\\AuthAs',
      settings: {
        crm_type: this.crmType,
        user_id: this.id,
      },
      from: null,
      to: null,
    });
  }
}
